<template>
    <div class="cable-configurator" :class="{'cable-configurator--with-dropdown' : displaySourceDropdown, 'cable-configurator--pre-existing' : isPreExistingSystem}">
        <div class="cable-configurator__wrapper">
            <VoltageRiseValidation :is-active="active" :is-valid="valid" />
            <!-- if source dropdown -->
            <div v-if="displaySourceDropdown" class="cable-configurator__items-wrapper">
                <span class="dropdown dropdown--source dropdown--icon-circle-chevron">
                    <v-select
                        v-model="selected"
                        placeholder="Select source"
                        :clearable="false"
                        :searchable="false"
                        :options="options"
                        @input="update"
                    />
                </span>
                <div class="cable-configurator__line cable-configurator__line--short" :class="{ 'cable-configurator__line--active' : active }" @click="$emit('activated')">
                    <Tooltip text="Select to configure cable" class="cable-configurator__line-tooltip" />
                </div>
                <div class="cable-configurator__destination" :class="'cable-configurator__destination--' + destination">
                    <span class="cable-configurator__destination-label">{{ destinationLabel }}</span>
                    <span class="cable-configurator__destination-power-output">{{ destinationPowerOutput }}</span>
                </div>
            </div>
            <!-- else  -->
            <div v-else class="cable-configurator__items-wrapper">
                <div class="cable-configurator__source" :class="'cable-configurator__source--' + source">{{ sourceLabel }}</div>
                <div class="cable-configurator__line" :class="{ 'cable-configurator__line--active' : active }" @click="$emit('activated')">
                    <Tooltip text="Select to configure cable" class="cable-configurator__line-tooltip" />
                </div>
                <div class="cable-configurator__destination" :class="'cable-configurator__destination--' + destination">{{ destinationLabel }}</div>
            </div>
        </div>
        <button v-if="isDistributionBoard || isPreExistingSystem" class="cable-configurator__delete-button" @click="$emit('removeItem')">Remove</button>

        <CableConfiguratorFields
            v-show="active"
            :cable="cable"
            :limitationdevice="limitationDevice"
            :supplies="options"
            :previous-cable-phase="displaySourceDropdown ? (selected ? selected.cable.phases : null) : previousCablePhase"
            :source-cable="displaySourceDropdown"
            :inverter-phase="destinationPhases"
            :is-pre-existing-system="isPreExistingSystem"
            :valid.sync="valid"
            class="cable-configurator__fields"
        />
    </div>
</template>

<script>
import Tooltip from '@/components/Tooltip';
import VoltageRiseValidation from '@/jobs/calculators/voltage-rise/VoltageRiseValidation';
import CableConfiguratorFields from '@/jobs/calculators/voltage-rise/CableConfiguratorFields';

export default {
    components: {
        Tooltip,
        VoltageRiseValidation,
        CableConfiguratorFields,
    },

    props:{
        options: {
            default: null
        },
        source: {
            default: ''
        },
        sourceLabel: {
            default: null
        },
        destination: {
            default: ''
        },
        destinationLabel: {
            default: ''
        },
        destinationPowerOutput: {
            default: ''
        },
        destinationPhases: {
            default: ''
        },
        cable: {
            default: {}
        },
        previousCablePhase: {
            default: null
        },
        limitationDevice: {
            type: Object,
            default: null
        },
        isDistributionBoard: {
            default: false
        },
        isPreExistingSystem: {
            default: false
        },
        displaySourceDropdown: {
            default: false
        },
        active: {
            default: false
        },
        node: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            loading: false,
            error: null,
            valid: false,
            selected: null,
        };
    },

    computed: {
        isValid() {
            if (this.displaySourceDropdown) {
                if (this.selected) {
                    return this.valid;
                }

                return false;
            }

            return this.valid
        },
    },

    mounted() {
        if (this.sourceLabel) {
            this.selected = this.options.filter(item => item.label == this.sourceLabel)[0];
        }
    },

    methods: {
        update(val) {
            this.$emit('update', val, this.node);
        },
    }
};
</script>
